import { render, staticRenderFns } from "./DatosAdicionales.vue?vue&type=template&id=14c72561&scoped=true&lang=html&"
import script from "./DatosAdicionales.vue?vue&type=script&lang=js&"
export * from "./DatosAdicionales.vue?vue&type=script&lang=js&"
import style0 from "./DatosAdicionales.vue?vue&type=style&index=0&id=14c72561&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c72561",
  null
  
)

export default component.exports